export default __webpack_public_path__ + "static/media/user-icon.c55585fd.png";